import { useParams } from '@hulu/react-router-dom';
import React from 'react';

import useStandardDeliveryDHCReport from '../../../../../apis/graphql/reports/standardDeliveryDHC/useStandardDeliveryDHCReport';
import { Loader, LoaderSize, LoaderType } from '../../../../../components';
import { Notification } from '../../../../../components/BlueTheme';
import { NotificationType } from '../../../../../components/BlueTheme/Notification/types';
import { TopBottomIndentsWrapper } from '../../../../../components/BlueTheme/Wrappers/styled';
import { DHCstorage } from '../../../constants/reports';
import { getStaticFilters } from '../../utils';
import StandardDeliveryDHC from '../StandardDeliveryDHC';
import { getDynamicFilters } from './utils';

type Props = {
  templateName: string;
};
const View = ({ templateName }: Props): JSX.Element => {
  const { reportId } = useParams();

  const { data: report, loading, error } = useStandardDeliveryDHCReport(reportId);

  if (loading) {
    return <Loader size={LoaderSize.big} type={LoaderType.transparent} />;
  }

  if (error || !report) {
    return (
      <TopBottomIndentsWrapper>
        <Notification type={NotificationType.error} description="Cannot get Report Data. Please try later." />
      </TopBottomIndentsWrapper>
    );
  }

  const storageReportId = DHCstorage?.getStorageData('reportId');
  if (!storageReportId || storageReportId !== report.id) {
    DHCstorage.setStorageData('reportId', report.id);
    DHCstorage.setStorageData('staticFilters', getStaticFilters(report));
    DHCstorage.setStorageData('dynamicFilters', getDynamicFilters(report));
  }

  return <StandardDeliveryDHC report={report} storage={DHCstorage} templateName={templateName} />;
};

export default View;
